module.exports = __webpack_public_path__ + "static/media/email-spark-cards.2d18c556.png";